import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import moment from 'moment';
import pick from 'lodash.pick';
import { httpAction } from '@/api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'SiteVisitorModal',
  components: {
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '访客登记表单',
      tableName: 'om_site_visitor',
      userTree: [],
      form_fields: ['siteId', 'userId', 'visitorReason', 'visitorCompany', 'visitorNum', 'remark'],
      form_fields_time: ['visitorDate', 'reportDate'],
      validatorRules: {
        visitorDate: {
          rules: [{
            required: true,
            message: '请输入来访时间!'
          }]
        },
        visitorNum: {
          rules: [{
            required: true,
            message: '请输入来访人数!'
          }]
        },
        visitorReason: {
          rules: [{
            required: true,
            message: '请输入来访原因!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.queryUserTreeList();
  },
  methods: {
    moment: moment,
    add: function add(siteId) {
      if (undefined == siteId) that.$message_custom('请选择单个站点', 'warning');
      this.edit({
        siteId: siteId
      });
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.model.userId = this.$store.getters.userInfo.id;
      if (undefined == this.model.reportDate) this.model.reportDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.visitorDate = formData.visitorDate ? formData.visitorDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.reportDate = formData.reportDate ? formData.reportDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this2.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};